<div class="modal-container">
    <div class="modal-top-bar">
        <h2>{{editMode ? 'Edit' : 'Create'}} schedule</h2>
    </div>
    <div class="modal-content edit-backup-schedule-container">
        <div>
            <div class="general">
                <div class="name">
                    <span class="form-field-header">Schedule name</span>
                    <input [(ngModel)]="schedule.name" type="text" placeholder="..."/>
                </div>
                <div class="schedule-time">
                    <span class="form-field-header">Executed at...</span>
                    <div>
                        <input type="number" [(ngModel)]="schedule.hour" min="0" max="23" step="1"/>
                        :
                        <input type="number" [(ngModel)]="schedule.minute" min="0" max="59" step="1"/>
                    </div>
                </div>
            </div>
            <div class="general">
                <div class="name">
                    <span class="form-field-header">Schedule backup path</span>
                    <input [(ngModel)]="schedule.path" type="text" placeholder="..."/>
                </div>
            </div>
            <div>
                <span class="form-field-header">Schedule days</span>
                <div class="schedule-days">
                    <div class="day" *ngFor="let day of daysOfWeek; index as i" (click)="toggleScheduleDay(schedule, i)" (keydown)="toggleScheduleDay(schedule, i)">
                        <mat-icon class="day-icon">{{isScheduleDayActive(schedule, i)? 'circle': 'radio_button_unchecked'}}</mat-icon>
                        <span>{{day}}</span>
                    </div>
                    <div class="day">
                        <button (click)="toggleMarkAllScheduleDays()" class="button outline mini">
                            {{allScheduleDaysSelected() ? 'Unmark all': 'Mark all'}}
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <span class="form-field-header">Storage device</span>
                <select class="mb-2 w-100" [ngModel]="getScheduleStorageId()" (ngModelChange)="changeScheduleStorage($event)">
                    <option [ngValue]="storageDevice.id" *ngFor="let storageDevice of storageDevices">
                        {{storageDevice.name}}
                    </option>
                </select>
                <div *ngIf="!!schedule.storageDevice" class="storage-devices-list">
                    <div class="device-row">
                        <div class="column">
                            <span>Name</span>
                            <span>{{schedule.storageDevice.name}}</span>
                        </div>
                        <div class="column">
                            <span>Address</span>
                            <span>{{schedule.storageDevice.address}}</span>
                        </div>
                        <div class="column">
                            <span>Root_folder</span>
                            <span>{{schedule.storageDevice.rootFolder}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="additional-checks">
                <mat-checkbox class="d-block" [(ngModel)]="schedule.enabled">Enable this schedule</mat-checkbox>
                <mat-checkbox *ngIf="!editMode" [(ngModel)]="schedule.runAfterCreation" class="d-block">Run this backup inmediately</mat-checkbox>
            </div>
        </div>
    </div>
    <div class="modal-bottom-bar">
        <button class="button outline mini wide" (click)="cancel()">Close</button>
        <button class="button mini wide" [disabled]="!validSchedule() || working" (click)="save()">{{working? 'Saving...': 'Save'}}</button>
    </div>
</div>
